import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { NswVoucherClient } from "../../parentApi";

const client = new NswVoucherClient(app_uri, axiosClient());

export default client;
